import { useEffect, useRef, useState } from 'react'
import { useCookies } from 'react-cookie'
import { VscChromeClose, VscChromeMinimize } from "react-icons/vsc";
import { useNavigate } from 'react-router-dom'

import Button from '../button/button'
import FooterTaps from './components/footerTaps';

import './footer.scss'

export type TapType = 'copyright' | 'console' | 'terminal'

type FooterPorps = {
  footerSize: number,
  setFooterSize: (explorerSize: number) => void
}

function Footer(props: Readonly<FooterPorps>) {
  const { footerSize, setFooterSize } = props
  const [cookies] = useCookies(['themen'])
  const [mousePosition] = useState({ y: 0 })
  const holdCountRef = useRef(mousePosition)
  const [isHolding, setIsHolding] = useState(false)
  const [activTab, setActivTab] = useState<TapType>('copyright')
  const navigate = useNavigate()

  const handleMouseMove = (event: MouseEvent) => {
    holdCountRef.current = { y: window.innerHeight - event.clientY }
  }

  useEffect(() => {
    if(cookies.themen) {
      document.getElementById('theme')?.classList.add(cookies.themen)
    }

    window.addEventListener('mousemove', handleMouseMove)
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [cookies.themen])

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined
    if (isHolding) {
      interval = setInterval(() => {

        if(holdCountRef.current.y < 60) {
          setFooterSize(0)
        } else if((window.innerHeight - 800) < holdCountRef.current.y) {
          setFooterSize(window.innerHeight - 800)
        } else {
          setFooterSize(holdCountRef.current.y)
        }

      }, 1)
    } else if (!isHolding) {
      clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [isHolding, setFooterSize])

  const handleMouseDown = () => {
    setIsHolding(true)
  }

  const handleMouseUp = () => {
    setIsHolding(false)
  }

  const handleMouseLeave = () => {
    setIsHolding(false)
  }

  return (
    <div className='comp-footer'>
      {isHolding ? (
        <div 
          className='footer-fullScreenStopper'
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
        />
      ) : null}

      <div className='footer-content'>
        <div className={`content-inner ${activTab === 'terminal' ? 'content-scrollable' : ''}`}>
          <div className='inner-taskbar'>
            <div className='taskbar-left'>
              <Button
                title={'FOOTER'}
                click={() => {setActivTab('copyright')}}
                size='small'
                activeInactive={activTab === 'copyright'}
              />
              <Button
                title={'DEBUG CONSOLE'}
                click={() => {setActivTab('console')}}
                size='small'
                activeInactive={activTab === 'console'}
                disabled
              />
              <Button
                title={'TERMINAL'}
                click={() => {setActivTab('terminal')}}
                size='small'
                activeInactive={activTab === 'terminal'}
              />
              <Button
                title={'PORTS'}
                click={() => {}}
                size='small'
                activeInactive={activTab === 'console'}
                disabled
              />
              <Button
                title={'IMPRESSUM'}
                click={() => {navigate('/impressum')}}
                size='small'
              />
            </div>
            <div className='taskbar-right'>
              <Button
                icon={<VscChromeMinimize />}
                click={() => {setFooterSize(80)}}
                size='small'
                style={{}}
              />
              <Button
                icon={<VscChromeClose />}
                click={() => {setFooterSize(0)}}
                size='small'
              />
            </div>
          </div>

          <FooterTaps activTab={activTab} />

        </div>
      </div>

      <div
        className={`footer-mouseBar ${isHolding ? 'footer-mouseBarActive' : ''} ${!isHolding && footerSize <= 0 ? 'footer-mouseBarClose' : ''}`}
        onMouseDown={handleMouseDown}
      />
    </div>
  )
}

export default Footer
